export const greekFlashcards = {
  categories: [
    {
      gr: "Γεια σας",
      rm: "Ya sas",
      en: "Hello (formal/plural)",
    },
    {
      gr: "Γεια σου",
      rm: "Ya sou",
      en: "Hello (informal/singular)",
    },
    {
      gr: "Καλημέρα",
      rm: "Kalimera",
      en: "Good morning / Good day",
    },
    {
      gr: "Καλησπέρα",
      rm: "Kalispera",
      en: "Good evening",
    },
    {
      gr: "Καληνύχτα",
      rm: "Kalinychta",
      en: "Good night",
    },
    {
      gr: "Αντίο",
      rm: "Antio",
      en: "Goodbye",
    },
    {
      gr: "Τα λέμε",
      rm: "Ta leme",
      en: "See you later",
    },
    {
      gr: "Παρακαλώ",
      rm: "Parakalo",
      en: "Please / You're welcome",
    },
    {
      gr: "Ευχαριστώ",
      rm: "Efharisto",
      en: "Thank you",
    },
    {
      gr: "Ευχαριστώ πολύ",
      rm: "Efharisto poli",
      en: "Thank you very much",
    },
    {
      gr: "Δεν πειράζει",
      rm: "Den pirazi",
      en: "It's okay / No problem",
    },
    {
      gr: "Συγγνώμη",
      rm: "Sygnomi",
      en: "Excuse me / Sorry",
    },
    {
      gr: "Ναι",
      rm: "Ne",
      en: "Yes",
    },
    {
      gr: "Όχι",
      rm: "Ohi",
      en: "No",
    },
    {
      gr: "Εντάξει",
      rm: "Entaxi",
      en: "Okay / Alright",
    },
    {
      gr: "Δεν καταλαβαίνω",
      rm: "Den katalaveno",
      en: "I don't understand",
    },
    {
      gr: "Μιλάτε αγγλικά;",
      rm: "Milate anglika?",
      en: "Do you speak English? (formal/plural)",
    },
    {
      gr: "Μιλάς αγγλικά;",
      rm: "Milas anglika?",
      en: "Do you speak English? (informal/singular)",
    },
    {
      gr: "Πώς είστε;",
      rm: "Pos eiste?",
      en: "How are you? (formal/plural)",
    },
    {
      gr: "Πώς είσαι;",
      rm: "Pos ise?",
      en: "How are you? (informal/singular)",
    },
    {
      gr: "Τι κάνετε;",
      rm: "Ti kanete?",
      en: "What are you doing? (formal/plural)",
    },
    {
      gr: "Τι κάνεις;",
      rm: "Ti kanis?",
      en: "What are you doing? (informal/singular)",
    },
    {
      gr: "Καλά, ευχαριστώ",
      rm: "Kala, efharisto",
      en: "I'm fine, thank you",
    },
    {
      gr: "Πώς σε λένε;",
      rm: "Pos se lene?",
      en: "What's your name?",
    },
    {
      gr: "Με λένε...",
      rm: "Me lene...",
      en: "My name is...",
    },
    {
      gr: "Πού είναι...;",
      rm: "Pou ine...?",
      en: "Where is...?",
    },
    {
      gr: "Πού είναι η τουαλέτα;",
      rm: "Pou ine i toualeta?",
      en: "Where is the toilet?",
    },
    {
      gr: "Πού είναι ο σταθμός του τρένου;",
      rm: "Pou ine o stathmos tou trenou?",
      en: "Where is the train station?",
    },
    {
      gr: "Πού είναι το αεροδρόμιο;",
      rm: "Pou ine to aerodromio?",
      en: "Where is the airport?",
    },
    {
      gr: "Πόσο κάνει;",
      rm: "Poso kani?",
      en: "How much does it cost?",
    },
    {
      gr: "Είναι πολύ ακριβό",
      rm: "Ine poli akrivo",
      en: "It's very expensive",
    },
    {
      gr: "Βοήθεια!",
      rm: "Voithia!",
      en: "Help!",
    },
    {
      gr: "Χρειάζομαι βοήθεια",
      rm: "Hriazome voithia",
      en: "I need help",
    },
    {
      gr: "Έχω χαθεί",
      rm: "Eho hathei",
      en: "I am lost",
    },
    {
      gr: "Ψάχνω...",
      rm: "Psahno...",
      en: "I'm looking for...",
    },
    {
      gr: "Θα ήθελα...",
      rm: "Tha ithela...",
      en: "I would like...",
    },
    {
      gr: "Θέλω...",
      rm: "Thelo...",
      en: "I want...",
    },
    {
      gr: "Έναν καφέ, παρακαλώ",
      rm: "Enan kafe, parakalo",
      en: "A coffee, please",
    },
    {
      gr: "Το λογαριασμό, παρακαλώ",
      rm: "To logariasmo, parakalo",
      en: "The bill, please",
    },
    {
      gr: "Είμαι χορτοφάγος",
      rm: "Ime hortofagos",
      en: "I am vegetarian",
    },
    {
      gr: "Έχω αλλεργία σε...",
      rm: "Eho alergia se...",
      en: "I am allergic to...",
    },
    {
      gr: "Είναι νόστιμο",
      rm: "Ine nostimo",
      en: "It's delicious",
    },
    {
      gr: "Στην υγειά σας!",
      rm: "Stin iyia sas!",
      en: "Cheers! (To your health)",
    },
    {
      gr: "Δεν αισθάνομαι καλά",
      rm: "Den esthánome kala",
      en: "I don't feel well",
    },
    {
      gr: "Πού είναι το νοσοκομείο;",
      rm: "Pou ine to nosokomio?",
      en: "Where is the hospital?",
    },
    {
      gr: "Μιλάω λίγα ελληνικά",
      rm: "Milao liga ellinika",
      en: "I speak a little Greek",
    },
    {
      gr: "Πιο αργά, παρακαλώ",
      rm: "Pio arga, parakalo",
      en: "Slower, please",
    },
    {
      gr: "Μπορείτε να επαναλάβετε;",
      rm: "Borite na epanalavete?",
      en: "Can you repeat that?",
    },
    {
      gr: "Είμαι κουρασμένος/η",
      rm: "Ime kourasmenos/i",
      en: "I am tired (male/female)",
    },
    {
      gr: "Τι καιρό κάνει;",
      rm: "Ti kero kani?",
      en: "What's the weather like?",
    },
    {
      gr: "Κάνει καλό καιρό",
      rm: "Kani kalo kero",
      en: "The weather is nice",
    },
    {
      gr: "Κάνει ζέστη",
      rm: "Kani zesti",
      en: "It's hot",
    },
    {
      gr: "Κάνει κρύο",
      rm: "Kani krio",
      en: "It's cold",
    },
    {
      gr: "Βρέχει",
      rm: "Vrehei",
      en: "It's raining",
    },
    {
      gr: "Συμφωνώ",
      rm: "Symfono",
      en: "I agree",
    },
    {
      gr: "Δεν συμφωνώ",
      rm: "Den symfono",
      en: "I disagree",
    },
    {
      gr: "Είναι ενδιαφέρον",
      rm: "Ine endiaferon",
      en: "It's interesting",
    },
    {
      gr: "Είναι σημαντικό",
      rm: "Ine simantiko",
      en: "It's important",
    },
    {
      gr: "Είναι δυνατόν",
      rm: "Ine dynaton",
      en: "It's possible",
    },
    {
      gr: "Είναι αδύνατον",
      rm: "Ine adynaton",
      en: "It's impossible",
    },
    {
      gr: "Τι ώρα είναι;",
      rm: "Ti ora ine?",
      en: "What time is it?",
    },
    {
      gr: "Σήμερα",
      rm: "Simera",
      en: "Today",
    },
    {
      gr: "Αύριο",
      rm: "Avrio",
      en: "Tomorrow",
    },
    {
      gr: "Χθες",
      rm: "Hthes",
      en: "Yesterday",
    },
    {
      gr: "Τώρα",
      rm: "Tora",
      en: "Now",
    },
    {
      gr: "Αργότερα",
      rm: "Argotera",
      en: "Later",
    },
    {
      gr: "Δεξιά",
      rm: "Dexia",
      en: "Right",
    },
    {
      gr: "Αριστερά",
      rm: "Aristera",
      en: "Left",
    },
    {
      gr: "Ευθεία",
      rm: "Evtheia",
      en: "Straight ahead",
    },
    {
      gr: "Κοντά",
      rm: "Konta",
      en: "Near",
    },
    {
      gr: "Μακριά",
      rm: "Makria",
      en: "Far",
    },
    {
      gr: "Είμαι χαμένος/η",
      rm: "Ime hamenos/i",
      en: "I'm lost (male/female)",
    },
    {
      gr: "Είμαι άρρωστος/η",
      rm: "Ime arrostos/i",
      en: "I'm sick (male/female)",
    },
    {
      gr: "Είναι επείγον",
      rm: "Ine epigon",
      en: "It's urgent",
    },
    {
      gr: "Μια στιγμή, παρακαλώ",
      rm: "Mia stigmi, parakalo",
      en: "One moment, please",
    },
    {
      gr: "Δεν ξέρω",
      rm: "Den xero",
      en: "I don't know",
    },
    {
      gr: "Είναι καλό",
      rm: "Ine kalo",
      en: "It's good / It's okay",
    },
    {
      gr: "Δεν πειράζει",
      rm: "Den pirazi",
      en: "It doesn't matter / Never mind",
    },
    {
      gr: "Κανένα πρόβλημα",
      rm: "Kanena provlima",
      en: "No problem",
    },
    {
      gr: "Πρόσεχε!",
      rm: "Prosehe!",
      en: "Be careful!",
    },
    {
      gr: "Άφησέ με ήσυχο/η",
      rm: "Afise me isyho/i",
      en: "Leave me alone (male/female)",
    },
    {
      gr: "Πεινάω",
      rm: "Pinao",
      en: "I'm hungry",
    },
    {
      gr: "Διψάω",
      rm: "Dipsao",
      en: "I'm thirsty",
    },
    {
      gr: "Λυπάμαι πολύ",
      rm: "Lipame poli",
      en: "I'm very sorry",
    },
    {
      gr: "Συγχαρητήρια!",
      rm: "Synharitiria!",
      en: "Congratulations!",
    },
    {
      gr: "Καλή τύχη!",
      rm: "Kali tyhi!",
      en: "Good luck!",
    },
    {
      gr: "Καλό ταξίδι!",
      rm: "Kalo taxidi!",
      en: "Have a good trip!",
    },
    {
      gr: "Στην υγειά μας!",
      rm: "Stin iyia mas!",
      en: "Cheers! (To our health)",
    },
    {
      gr: "Είναι δωρεάν;",
      rm: "Ine dorean?",
      en: "Is it free?",
    },
    {
      gr: "Ποιος είναι ο κωδικός του wifi;",
      rm: "Pios ine o kodikos tou wifi?",
      en: "What is the wifi password?",
    },
    {
      gr: "Μπορώ να βγάλω μια φωτογραφία;",
      rm: "Boro na vgálo mia fotografia?",
      en: "Can I take a picture?",
    },
  ],
};
